export default __webpack_public_path__ + "static/article-renovation-sustain-4c7e5ebd383279cd1fdf87a25efde58a.jpg";